import script from "./FixedPromoMessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixedPromoMessageItem.vue?vue&type=script&setup=true&lang=ts"

import "./FixedPromoMessageItem.vue?vue&type=style&index=0&id=1479d924&lang=scss"

const __exports__ = script;

export default __exports__